module.exports = __webpack_public_path__ + "prod/1.42.2/img/tiantu-icon.7d1cc0ad.png";